import React, { useContext, useEffect, useRef, useState } from "react";
import { getData } from "../services/API";
import ThemeOne from "../components/ResumeThemes/ThemeOne";
import ThemeTwo from "../components/ResumeThemes/ThemeTwo";
import ThemeThree from "../components/ResumeThemes/ThemeThree";
import ThemeFour from "../components/ResumeThemes/ThemeFour";
import { useReactToPrint } from "react-to-print";
import { UserData } from "../contexts/UserInfoContext";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { useParams } from "react-router-dom";
import avatar from "../images/avatar.png";
import { toFarsiNumber } from "../helper/helper";

const FacultyResume = () => {
  const { user, userLoaded } = useContext(UserData);
  const [loading, setLoading] = useState(true);
  const [once, setOnce] = useState(true);
  const [resume, setResume] = useState({});
  const printCom = useRef();

  const themes = [
    { id: 1, element: <ThemeOne /> },
    { id: 2, element: <ThemeTwo /> },
    { id: 3, element: <ThemeThree /> },
    { id: 4, element: <ThemeFour /> },
  ];

  const param = useParams();

  useEffect(() => {
    const element = document.querySelector('meta[name="viewport"]');
    element.setAttribute("content", "width=1024");

    if (once) {
      setOnce(false);
      getData(`/faculty-list-id/${param.id}`).then((res) => {
        setLoading(false);
        setResume(res.data);
      });
    }
  }, [userLoaded]);

  const handlePrint = useReactToPrint({
    content: () => printCom.current,
  });

  return (
    <div className="w-full min-h-screen h-auto flex flex-col gap-5 py-10 items-center bg-white overflow-x-hidden">
      {loading ? (
        <span className="text-2xl font-black">لطفا صبر کنید...</span>
      ) : (
        <>
          <button
            onClick={handlePrint}
            className="w-32 h-11 self-center flex justify-center items-center rounded-xl font-black text-white bg-gradient-to-tl from-green-700 to-green-400"
          >
            دانلود رزومه
          </button>
          <div ref={printCom} className="resume-wrapper w-fit h-fit">
            {/* {themes[resume.theme - 1].element} */}
            <div className="min-w-[795px] max-w-[795px] h-auto border m-10 pb-10">
              <div className="flex gap-4 items-center pr-6">
                <img
                  src={
                    resume?.pic_url
                      ? `https://api.myunibest.com/${resume?.pic_url}`
                      : avatar
                  }
                  className="rounded-full w-[150px] h-[150px] object-cover z-10"
                  alt=""
                />

                <div className="resume-bg relative w-full h-48 bg-red-100 pr-16 py-3">
                  <div className="flex gap-5 pl-4">
                    <div className="w-[230px] flex flex-col text-sm text-white">
                      <h1 className="text-xl">
                        {resume.name + " " + resume.family_name}
                      </h1>
                      <span className="pb-2 border-b border-dashed">
                        {/* {resume.job_info?.title} */}
                      </span>
                      <span className="pt-2 pb-1">
                        کد ملی : {toFarsiNumber(resume.melli_code)}
                      </span>
                      {/* <span>وضعیت سربازی : {resume.basic_info?.army?.name}</span> */}
                    </div>

                    <div className="flex flex-col pt-2 gap-5 text-white text-sm">
                      {/* شماره تلفن */}
                      <div className="flex items-center gap-2">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="#fff"
                          className="w-5 h-5"
                        >
                          <path d="M10.5 18.75a.75.75 0 000 1.5h3a.75.75 0 000-1.5h-3z" />
                          <path
                            fillRule="evenodd"
                            d="M8.625.75A3.375 3.375 0 005.25 4.125v15.75a3.375 3.375 0 003.375 3.375h6.75a3.375 3.375 0 003.375-3.375V4.125A3.375 3.375 0 0015.375.75h-6.75zM7.5 4.125C7.5 3.504 8.004 3 8.625 3H9.75v.375c0 .621.504 1.125 1.125 1.125h2.25c.621 0 1.125-.504 1.125-1.125V3h1.125c.621 0 1.125.504 1.125 1.125v15.75c0 .621-.504 1.125-1.125 1.125h-6.75A1.125 1.125 0 017.5 19.875V4.125z"
                            clipRule="evenodd"
                          />
                        </svg>

                        <span>{toFarsiNumber(resume.phone_number)}</span>
                      </div>

                      {/* آدرس */}
                      <div className="flex items-center gap-2 text-xs">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="#fff"
                          className="w-6 h-6"
                        >
                          <path
                            fillRule="evenodd"
                            d="M11.54 22.351l.07.04.028.016a.76.76 0 00.723 0l.028-.015.071-.041a16.975 16.975 0 001.144-.742 19.58 19.58 0 002.683-2.282c1.944-1.99 3.963-4.98 3.963-8.827a8.25 8.25 0 00-16.5 0c0 3.846 2.02 6.837 3.963 8.827a19.58 19.58 0 002.682 2.282 16.975 16.975 0 001.145.742zM12 13.5a3 3 0 100-6 3 3 0 000 6z"
                            clipRule="evenodd"
                          />
                        </svg>

                        <span>{resume.address}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="flex flex-col gap-10 px-6 mt-8">
                {/* سوابق تحصیلی */}
                <div className="flex flex-col gap-5">
                  <div className="border-b pb-3 border-dashed flex items-center gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="size-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M4.26 10.147a60.438 60.438 0 0 0-.491 6.347A48.62 48.62 0 0 1 12 20.904a48.62 48.62 0 0 1 8.232-4.41 60.46 60.46 0 0 0-.491-6.347m-15.482 0a50.636 50.636 0 0 0-2.658-.813A59.906 59.906 0 0 1 12 3.493a59.903 59.903 0 0 1 10.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0 1 12 13.489a50.702 50.702 0 0 1 7.74-3.342M6.75 15a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Zm0 0v-3.675A55.378 55.378 0 0 1 12 8.443m-7.007 11.55A5.981 5.981 0 0 0 6.75 15.75v-1.5"
                      />
                    </svg>

                    <h3 className="font-semibold">سوابق تحصیلی</h3>
                  </div>

                  <p className="text-sm text-gray-600 whitespace-pre-wrap">{resume.edu_history}</p>
                </div>

                <div className="flex flex-col gap-5">
                  <div className="border-b pb-3 border-dashed flex items-center gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="size-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M20.25 14.15v4.25c0 1.094-.787 2.036-1.872 2.18-2.087.277-4.216.42-6.378.42s-4.291-.143-6.378-.42c-1.085-.144-1.872-1.086-1.872-2.18v-4.25m16.5 0a2.18 2.18 0 0 0 .75-1.661V8.706c0-1.081-.768-2.015-1.837-2.175a48.114 48.114 0 0 0-3.413-.387m4.5 8.006c-.194.165-.42.295-.673.38A23.978 23.978 0 0 1 12 15.75c-2.648 0-5.195-.429-7.577-1.22a2.016 2.016 0 0 1-.673-.38m0 0A2.18 2.18 0 0 1 3 12.489V8.706c0-1.081.768-2.015 1.837-2.175a48.111 48.111 0 0 1 3.413-.387m7.5 0V5.25A2.25 2.25 0 0 0 13.5 3h-3a2.25 2.25 0 0 0-2.25 2.25v.894m7.5 0a48.667 48.667 0 0 0-7.5 0M12 12.75h.008v.008H12v-.008Z"
                      />
                    </svg>

                    <h3 className="font-semibold">سوابق کاری</h3>
                  </div>

                  <p className="text-sm text-gray-600 whitespace-pre-wrap">{resume.work_history}</p>
                </div>

                <div className="flex flex-col gap-5">
                  <div className="border-b pb-3 border-dashed flex items-center gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="size-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M3.75 3v11.25A2.25 2.25 0 0 0 6 16.5h2.25M3.75 3h-1.5m1.5 0h16.5m0 0h1.5m-1.5 0v11.25A2.25 2.25 0 0 1 18 16.5h-2.25m-7.5 0h7.5m-7.5 0-1 3m8.5-3 1 3m0 0 .5 1.5m-.5-1.5h-9.5m0 0-.5 1.5m.75-9 3-3 2.148 2.148A12.061 12.061 0 0 1 16.5 7.605"
                      />
                    </svg>

                    <h3 className="font-semibold">سوابق تدریس</h3>
                  </div>

                  <p className="text-sm text-gray-600 whitespace-pre-wrap">
                    {resume.teach_history}
                  </p>
                </div>

                <div className="flex flex-col gap-5">
                  <div className="border-b pb-3 border-dashed flex items-center gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="size-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 21v-8.25M15.75 21v-8.25M8.25 21v-8.25M3 9l9-6 9 6m-1.5 12V10.332A48.36 48.36 0 0 0 12 9.75c-2.551 0-5.056.2-7.5.582V21M3 21h18M12 6.75h.008v.008H12V6.75Z"
                      />
                    </svg>

                    <h3 className="font-semibold">حوزه و دوره تدریس</h3>
                  </div>

                  <p className="text-sm text-gray-600 whitespace-pre-wrap">
                    {resume.teach_department}
                  </p>
                </div>

                <div className="flex flex-col gap-5">
                  <div className="border-b pb-3 border-dashed flex items-center gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="size-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M12 21a9.004 9.004 0 0 0 8.716-6.747M12 21a9.004 9.004 0 0 1-8.716-6.747M12 21c2.485 0 4.5-4.03 4.5-9S14.485 3 12 3m0 18c-2.485 0-4.5-4.03-4.5-9S9.515 3 12 3m0 0a8.997 8.997 0 0 1 7.843 4.582M12 3a8.997 8.997 0 0 0-7.843 4.582m15.686 0A11.953 11.953 0 0 1 12 10.5c-2.998 0-5.74-1.1-7.843-2.918m15.686 0A8.959 8.959 0 0 1 21 12c0 .778-.099 1.533-.284 2.253m0 0A17.919 17.919 0 0 1 12 16.5c-3.162 0-6.133-.815-8.716-2.247m0 0A9.015 9.015 0 0 1 3 12c0-1.605.42-3.113 1.157-4.418"
                      />
                    </svg>

                    <h3 className="font-semibold">
                      سوابق و تاثیرگذاری کارآفرینی
                    </h3>
                  </div>

                  <p className="text-sm text-gray-600 whitespace-pre-wrap">
                    {resume.startup_history}
                  </p>
                </div>

                <div className="flex flex-col gap-5">
                  <div className="border-b pb-3 border-dashed flex items-center gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="size-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 0 1-.825-.242m9.345-8.334a2.126 2.126 0 0 0-.476-.095 48.64 48.64 0 0 0-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0 0 11.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
                      />
                    </svg>

                    <h3 className="font-semibold">سوابق مشاوره</h3>
                  </div>

                  <p className="text-sm text-gray-600 whitespace-pre-wrap">{resume.cons_history}</p>
                </div>

                <div className="flex flex-col gap-5">
                  <div className="border-b pb-3 border-dashed flex items-center gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="size-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M18 18.72a9.094 9.094 0 0 0 3.741-.479 3 3 0 0 0-4.682-2.72m.94 3.198.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0 1 12 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 0 1 6 18.719m12 0a5.971 5.971 0 0 0-.941-3.197m0 0A5.995 5.995 0 0 0 12 12.75a5.995 5.995 0 0 0-5.058 2.772m0 0a3 3 0 0 0-4.681 2.72 8.986 8.986 0 0 0 3.74.477m.94-3.197a5.971 5.971 0 0 0-.94 3.197M15 6.75a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm6 3a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Zm-13.5 0a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0Z"
                      />
                    </svg>

                    <h3 className="font-semibold">
                      سوابق برگذاری همایش و موضوع همایش
                    </h3>
                  </div>

                  <p className="text-sm text-gray-600 whitespace-pre-wrap">
                    {resume.event_history}
                  </p>
                </div>

                <div className="flex flex-col gap-5">
                  <div className="border-b pb-3 border-dashed flex items-center gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      class="size-6"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 0 0 2.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 0 0-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 0 0 .75-.75 2.25 2.25 0 0 0-.1-.664m-5.8 0A2.251 2.251 0 0 1 13.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25ZM6.75 12h.008v.008H6.75V12Zm0 3h.008v.008H6.75V15Zm0 3h.008v.008H6.75V18Z"
                      />
                    </svg>

                    <h3 className="font-semibold">سایر موارد قابل ذکر</h3>
                  </div>

                  <p className="text-sm text-gray-600 whitespace-pre-wrap">
                    {resume.other}
                  </p>
                </div>

                {/* سوابق تحصیلی */}
                {/* <div className="flex flex-col gap-5">
                  <div className="border-b pb-3 border-dashed flex items-center gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-6 h-6"
                    >
                      <path d="M11.7 2.805a.75.75 0 01.6 0A60.65 60.65 0 0122.83 8.72a.75.75 0 01-.231 1.337 49.949 49.949 0 00-9.902 3.912l-.003.002-.34.18a.75.75 0 01-.707 0A50.009 50.009 0 007.5 12.174v-.224c0-.131.067-.248.172-.311a54.614 54.614 0 014.653-2.52.75.75 0 00-.65-1.352 56.129 56.129 0 00-4.78 2.589 1.858 1.858 0 00-.859 1.228 49.803 49.803 0 00-4.634-1.527.75.75 0 01-.231-1.337A60.653 60.653 0 0111.7 2.805z" />
                      <path d="M13.06 15.473a48.45 48.45 0 017.666-3.282c.134 1.414.22 2.843.255 4.285a.75.75 0 01-.46.71 47.878 47.878 0 00-8.105 4.342.75.75 0 01-.832 0 47.877 47.877 0 00-8.104-4.342.75.75 0 01-.461-.71c.035-1.442.121-2.87.255-4.286A48.4 48.4 0 016 13.18v1.27a1.5 1.5 0 00-.14 2.508c-.09.38-.222.753-.397 1.11.452.213.901.434 1.346.661a6.729 6.729 0 00.551-1.608 1.5 1.5 0 00.14-2.67v-.645a48.549 48.549 0 013.44 1.668 2.25 2.25 0 002.12 0z" />
                      <path d="M4.462 19.462c.42-.419.753-.89 1-1.394.453.213.902.434 1.347.661a6.743 6.743 0 01-1.286 1.794.75.75 0 11-1.06-1.06z" />
                    </svg>

                    <h3 className="font-semibold">سوابق کاری</h3>
                  </div>

                  <div className="grid grid-cols-2 text-gray-600">
                    {resume.edu_info?.length > 0
                      ? resume.edu_info?.map((edu) => (
                          <div className="flex flex-col gap-2 text-xs">
                            <h2 className="text-sm font-semibold text-gray-700">
                              {edu.title}
                            </h2>
                            <span>مقطع تحصیلی: {edu.grade.name}</span>
                            <span>موسسه/دانشگاه: {edu.college_name}</span>
                          </div>
                        ))
                      : "اطلاعات تحصیلی ثبت نشده!"}
                  </div>
                </div> */}

                {/* سوابق شغلی */}
                {/* <div className="flex flex-col gap-5">
                  <div className="border-b pb-3 border-dashed flex items-center gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.5 5.25a3 3 0 013-3h3a3 3 0 013 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0112 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 017.5 5.455V5.25zm7.5 0v.09a49.488 49.488 0 00-6 0v-.09a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5zm-3 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
                        clipRule="evenodd"
                      />
                      <path d="M3 18.4v-2.796a4.3 4.3 0 00.713.31A26.226 26.226 0 0012 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 01-6.477-.427C4.047 21.128 3 19.852 3 18.4z" />
                    </svg>

                    <h3 className="font-semibold">سوابق شغلی</h3>
                  </div>

                  <div className="grid grid-cols-2 text-gray-600">
                    {resume.past_jobs?.length > 0
                      ? resume.past_jobs?.map((job) => (
                          <div className="flex flex-col gap-2 text-xs">
                            <h2 className="text-sm font-semibold text-gray-700">
                              {job.title}
                            </h2>
                            <span>نام شرکت: {job.company_name}</span>

                            <span>
                              {job.start_date
                                ? new Intl.DateTimeFormat("fa-IR", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  }).format(new Date(job.start_date))
                                : "ثبت نشده"}{" "}
                              -{" "}
                              {job.end_date && !job.working
                                ? new Intl.DateTimeFormat("fa-IR", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  }).format(new Date(job.end_date))
                                : "مشغول به کار"}
                            </span>

                            <p className="pl-3">{job.description}</p>
                          </div>
                        ))
                      : "سوابق شغلی ثبت نشده"}
                  </div>
                </div> */}

                {/* مهارت‌ها */}
                {/* <div className="flex flex-col gap-5">
                  <div className="border-b pb-3 border-dashed flex items-center gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.5 5.25a3 3 0 013-3h3a3 3 0 013 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0112 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 017.5 5.455V5.25zm7.5 0v.09a49.488 49.488 0 00-6 0v-.09a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5zm-3 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
                        clipRule="evenodd"
                      />
                      <path d="M3 18.4v-2.796a4.3 4.3 0 00.713.31A26.226 26.226 0 0012 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 01-6.477-.427C4.047 21.128 3 19.852 3 18.4z" />
                    </svg>

                    <h3 className="font-semibold">مهارت‌ها</h3>
                  </div>

                  <div className="grid grid-cols-2 gap-10 text-gray-600">
                    {resume.skills?.length > 0
                      ? resume.skills?.map((skill) => (
                          <div className="flex items-center justify-between">
                            <span>{skill.title}</span>
                            <div className="flex gap-1">
                              {circle.map((item, i) =>
                                i + 1 <= Number(skill.level.code) ? (
                                  <span className="block w-3 h-3 bg-black rounded-full"></span>
                                ) : (
                                  <span className="size-3 rounded-full bg-gray-300 block"></span>
                                )
                              )}
                            </div>
                          </div>
                        ))
                      : "مهارتی ثبت نشده است"}
                  </div>
                </div> */}

                {/* زبان */}
                {/* <div className="flex flex-col gap-5">
                  <div className="border-b pb-3 border-dashed flex items-center gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.5 5.25a3 3 0 013-3h3a3 3 0 013 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0112 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 017.5 5.455V5.25zm7.5 0v.09a49.488 49.488 0 00-6 0v-.09a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5zm-3 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
                        clipRule="evenodd"
                      />
                      <path d="M3 18.4v-2.796a4.3 4.3 0 00.713.31A26.226 26.226 0 0012 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 01-6.477-.427C4.047 21.128 3 19.852 3 18.4z" />
                    </svg>

                    <h3 className="font-semibold">زبان</h3>
                  </div>

                  {resume.langs?.length > 0
                    ? resume.langs?.map((lang) => (
                        <div className="w-full flex flex-col gap-3">
                          <h3 className="text-sm text-gray-500 font-semibold">
                            {lang.title}
                          </h3>

                          <div className="grid grid-cols-4 text-gray-600">
                            <div className="flex text-[13px] items-center gap-5">
                              <span>مهارت خواندن</span>
                              <div className="flex gap-1">
                                {circle.map((item, i) =>
                                  i + 1 <= Number(lang.level.code) ? (
                                    <span className="block w-3 h-3 bg-black rounded-full"></span>
                                  ) : (
                                    <span className="size-3 rounded-full bg-gray-300 block"></span>
                                  )
                                )}
                              </div>
                            </div>

                            <div className="flex text-[13px] items-center gap-5">
                              <span>مهارت نوشتن</span>
                              <div className="flex gap-1">
                                {circle.map((item, i) =>
                                  i + 1 <= Number(lang.level.code) ? (
                                    <span className="block w-3 h-3 bg-black rounded-full"></span>
                                  ) : (
                                    <span className="size-3 rounded-full bg-gray-300 block"></span>
                                  )
                                )}
                              </div>
                            </div>

                            <div className="flex text-[13px] items-center gap-5">
                              <span>مهارت گفتاری</span>
                              <div className="flex gap-1">
                                {circle.map((item, i) =>
                                  i + 1 <= Number(lang.level.code) ? (
                                    <span className="block w-3 h-3 bg-black rounded-full"></span>
                                  ) : (
                                    <span className="size-3 rounded-full bg-gray-300 block"></span>
                                  )
                                )}
                              </div>
                            </div>

                            <div className="flex text-[13px] items-center gap-5">
                              <span>مهارت شنیداری</span>
                              <div className="flex gap-1">
                                {circle.map((item, i) =>
                                  i + 1 <= Number(lang.level.code) ? (
                                    <span className="block w-3 h-3 bg-black rounded-full"></span>
                                  ) : (
                                    <span className="size-3 rounded-full bg-gray-300 block"></span>
                                  )
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      ))
                    : "زبان ثبت نشده است"}
                </div> */}

                {/* دوره هاو گواهینامه ها */}
                {/* {resume.courses?.length > 0 && (
                  <div className="flex flex-col gap-5">
                    <div className="border-b pb-3 border-dashed flex items-center gap-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          fillRule="evenodd"
                          d="M7.5 5.25a3 3 0 013-3h3a3 3 0 013 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0112 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 017.5 5.455V5.25zm7.5 0v.09a49.488 49.488 0 00-6 0v-.09a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5zm-3 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
                          clipRule="evenodd"
                        />
                        <path d="M3 18.4v-2.796a4.3 4.3 0 00.713.31A26.226 26.226 0 0012 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 01-6.477-.427C4.047 21.128 3 19.852 3 18.4z" />
                      </svg>

                      <h3 className="font-semibold">دوره ها و گواهینامه ها</h3>
                    </div>

                    <div className="grid grid-cols-2 text-gray-600">
                      {resume.courses.length > 0
                        ? resume.courses.map((course) => (
                            <div className="flex flex-col gap-2 text-xs">
                              <h2 className="text-sm font-semibold text-gray-700">
                                {course.title}
                              </h2>
                              <span>
                                {course.start_date
                                  ? new Intl.DateTimeFormat("fa-IR", {
                                      year: "numeric",
                                      month: "short",
                                      day: "numeric",
                                    }).format(new Date(course.start_date))
                                  : "ثبت نشده"}{" "}
                                -{" "}
                                {course.end_date && !course.working
                                  ? new Intl.DateTimeFormat("fa-IR", {
                                      year: "numeric",
                                      month: "short",
                                      day: "numeric",
                                    }).format(new Date(course.end_date))
                                  : "دوره درحال برگذاری است"}
                              </span>

                              <p className="pl-3">{course.description}</p>
                            </div>
                          ))
                        : "سوابق شغلی ثبت نشده"}
                    </div>
                  </div>
                )} */}

                {/* پروژه ها */}
                {/* <div className="flex flex-col gap-5">
                  <div className="border-b pb-3 border-dashed flex items-center gap-3">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      className="w-6 h-6"
                    >
                      <path
                        fillRule="evenodd"
                        d="M7.5 5.25a3 3 0 013-3h3a3 3 0 013 3v.205c.933.085 1.857.197 2.774.334 1.454.218 2.476 1.483 2.476 2.917v3.033c0 1.211-.734 2.352-1.936 2.752A24.726 24.726 0 0112 15.75c-2.73 0-5.357-.442-7.814-1.259-1.202-.4-1.936-1.541-1.936-2.752V8.706c0-1.434 1.022-2.7 2.476-2.917A48.814 48.814 0 017.5 5.455V5.25zm7.5 0v.09a49.488 49.488 0 00-6 0v-.09a1.5 1.5 0 011.5-1.5h3a1.5 1.5 0 011.5 1.5zm-3 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z"
                        clipRule="evenodd"
                      />
                      <path d="M3 18.4v-2.796a4.3 4.3 0 00.713.31A26.226 26.226 0 0012 17.25c2.892 0 5.68-.468 8.287-1.335.252-.084.49-.189.713-.311V18.4c0 1.452-1.047 2.728-2.523 2.923-2.12.282-4.282.427-6.477.427a49.19 49.19 0 01-6.477-.427C4.047 21.128 3 19.852 3 18.4z" />
                    </svg>

                    <h3 className="font-semibold">پروژه ها</h3>
                  </div>

                  <div className="flex flex-col gap-5 text-gray-600">
                    {resume.projects?.length > 0
                      ? resume.projects?.map((project) => (
                          <div className="flex flex-col gap-2 text-xs">
                            <h2 className="text-sm font-semibold">
                              {project.title}
                            </h2>
                            <span>
                              {project.start_date
                                ? new Intl.DateTimeFormat("fa-IR", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  }).format(new Date(project.start_date))
                                : "ثبت نشده"}{" "}
                              -{" "}
                              {project.end_date && !project.working
                                ? new Intl.DateTimeFormat("fa-IR", {
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric",
                                  }).format(new Date(project.end_date))
                                : "درحال انجام"}
                            </span>

                            <p className="text-sm">{project.description}</p>
                            <div className="flex items-center gap-2">
                              <span>لینک :</span>
                              <a
                                href={project.link}
                                target="_blank"
                                className="text-blue-600 underline"
                              >
                                {project.link}
                              </a>
                            </div>
                          </div>
                        ))
                      : "پروژه ای ثبت نشده است"}
                  </div>
                </div> */}
              </div>
            </div>
          </div>
          {/* <TransformWrapper maxScale={0.5} initialScale={0.1}>
            <TransformComponent>
            </TransformComponent>
          </TransformWrapper> */}
        </>
      )}
    </div>
  );
};

export default FacultyResume;
